<template>
  <span class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium" :class="badgeClass">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  status: string
}>()

const badgeClass = computed(() => {
  switch (props.status) {
    case 'completed':
      return 'bg-green-500/20 text-green-400'
    case 'failed':
      return 'bg-red-500/20 text-red-400'
    case 'overridden':
      return 'bg-amber-500/20 text-amber-400'
    case 'running':
      return 'bg-blue-500/20 text-blue-400'
    case 'pending':
    case 'scheduled':
      return 'bg-surface-500/20 text-surface-400'
    case 'skipped':
      return 'bg-surface-500/20 text-surface-500 italic'
    case 'cancelled':
      return 'bg-surface-500/20 text-surface-500 line-through'
    default:
      return 'bg-surface-500/20 text-surface-400'
  }
})

const label = computed(() => {
  return props.status.charAt(0).toUpperCase() + props.status.slice(1)
})
</script>
